import { array, intersect, partial, string, struct } from 'io-ts/Decoder';

export const Request = intersect(
	struct({
		label: string,
		sectionId: string,
	})
)(
	partial({
		values: array(string),
	})
);
